import React, { useState } from 'react'

import { useReportingBasis } from './ReportingBasisProvider'
import { ReportingBasisToggle } from './ReportingBasisToggle'
import { type ReportingBasis } from './types'

export const ReportingBasisToggleContainer = () => {
  const { basis, setBasis } = useReportingBasis()
  const [isUpdating, setIsUpdating] = useState(false)

  if (!basis || !setBasis) {
    return null
  }

  const handleChange = async (next: ReportingBasis) => {
    if (isUpdating) return
    setIsUpdating(true)
    try {
      await setBasis(next)
    } catch {
      // setBasis already logs and reverts optimistic state; swallow here
      // so the caller's sync onClick doesn't surface an unhandled rejection.
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <div className='Layer__Stack' data-direction='column' style={{ order: 9999 }}>
      <label
        className='Layer__Label'
        data-size='sm'
        data-pbe='3xs'
      >
        Basis
      </label>
      <ReportingBasisToggle
        value={basis}
        onChange={handleChange}
        disabled={isUpdating}
      />
    </div>
  )
}
